import {
  CREATE_JOB_APPLICATION_MUTATION,
  UPLOAD_FILE_MUTATION,
} from "@/apollo/mutations";
import { CAREER_QUERY } from "@/apollo/queries";
import Banner from "@/components/Banner";
import BenfitCard from "@/components/Card/BenfitCard";
import Loader from "@/components/Loader";
import SEOHead from "@/components/SEO";
import { useMutation, useQuery } from "@apollo/client";
import {
  Box,
  Button,
  Container,
  Flex,
  Grid,
  Heading,
  Link,
  Stack,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Select,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Icon,
  InputGroup,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { FiFile } from "react-icons/fi";
import ReCAPTCHA from "react-google-recaptcha";
import JobPosting from "@/components/SEO/JobPosting";
import { Select as SelectC } from "chakra-react-select";

const Career = (props) => {
  const inputRef = useRef(null);
  const recaptchaRef = React.useRef(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isVisible,
    onClose: alertClose,
    onOpen: alertOpen,
  } = useDisclosure({ defaultIsOpen: false });

  useEffect(() => {
    if (isVisible) {
      removeAlert();
    }
  }, [isVisible]);

  const handleClick = () => inputRef.current?.click();

  const handleFileUpload = (e) => {
    setUploadedFile(e.target.files[0]);
  };

  const [fullName, setFullName] = useState(null);
  const [email, setEmail] = useState(null);
  const [contact, setContact] = useState(null);
  const [englishLevel, setEnglishLevel] = useState("Advanced");
  const [skillLevel, setSkillLevel] = useState("Advanced");
  const [applyingFor, setApplyingFor] = useState([]);
  const stringapplyingFor = JSON.stringify(applyingFor)
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isSubmiited, setIsSubmitted] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [captchaError, setCaptchaError] = useState(null);
  // const [defaultApplyInpt, setDefaultApplyInpt] = useState(null);

  const [createJobApplication, { loading: jobLoading, data: jobData }] =
    useMutation(CREATE_JOB_APPLICATION_MUTATION);
  const [uploadSingleFile, { loading: fileLoading, data: fileData }] =
    useMutation(UPLOAD_FILE_MUTATION);

  const { loading, error, data } = useQuery(CAREER_QUERY);
  if (loading) {
    return <Loader />;
  }

  if (error) {
    console.error(error);
    return null;
  }
  const {
    MainSec,
    Contact_Us,
    current_openings,
    Benefits,
    Title,
    Description,
    SEO,
  } = data.career.data.attributes;
  const {
    Title: BenifitTitle,
    Description: BenifitDesc,
    TitleIconSection,
  } = Benefits;
  const developersArray = current_openings.data.filter((job) => job.attributes.isOpening).map((job) => job.attributes.Developer);
  const newArray = developersArray.map((i)=> ({ value: i, label: i }));
  const groupedOptions = [{options: newArray}];
  const handleApplyNow = async (e) => {
    try {
      setIsSubmitted(true);
      e.preventDefault();
      uploadSingleFile({
        variables: {
          file: uploadedFile,
        },
      })
        .then((res) => {
          const fileId = res.data.upload.data.id;

          createJobApplication({
            variables: {
              data: {
                Applying_for: stringapplyingFor,
                Contact: contact,
                Email: email,
                English_Level: englishLevel,
                Skill_Level: skillLevel,
                Full_Name: fullName,
                file: fileId,
              },
            },
          }).then(({ errors }) => {
            if (!errors) {
              // removeAlert();
              setIsSubmitted(false);
            }
          });
          onClose();
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          // alertOpen();
          if (!jobLoading) {
            alertOpen();
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } catch (error) {
      console.log("🚀 ~ file: careers.js:163 ~ handleApplyNow ~ error:", error);
    } finally {
      setIsDisabled(true);
      setFullName("");
      setEmail("");
      setContact("");
      setApplyingFor([]);
      setUploadedFile(null);
      recaptchaRef.current.reset();
    }
  };

  const onReCAPTCHAChange = async (token) => {
    try {
      if (!token) {
        setCaptchaError("captcha verification invalid or expired.");
        return;
      } else {
        const response = await fetch("/api/verifyCaptchaToken", {
          method: "POST",
          body: JSON.stringify({ captcha: token }),
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.ok) {
          setIsDisabled(false);
        } else {
          const error = await response.json();
          // throw new Error(error.message);
          console.error(error.message);
          setCaptchaError(error.message);
        }
      }
    } catch (error) {
      console.error(error);
      setCaptchaError("something went wrong.");
    }
  };

  const removeAlert = () => {
    setTimeout(() => {
      alertClose();
    }, 7000);
  };

  const tableCaptionBreak = {
    width: "full",
    display: { base: "flex", md: "flex", lg: "table-caption" },
    flexDirection: "column",
  };

  const tableHeading = {
    fontWeight: "medium",
    color: "white",
    fontSize: "md",
    letterSpacing: 0,
    textTransform: "capitalize",
    fontWeight: 600,
  };

  const tableContent = {
    textAlign: "left",
    fontWeight: "medium",
    fontSize: { base: "sm", md: "md" },
    letterSpacing: 0,
    color: "gray.10",
  };

  const Headings = [
    "Job Title",
    "Experience",
    "Vacancies",
    "Qualification",
    "",
  ];

  return (
    <>
      <SEOHead title={SEO.pageTitle} description={SEO.pageDescription} />
      {/* JobPosting - for JobPosting structured data schema 
      [INFO]: https://developers.google.com/search/docs/appearance/structured-data/job-posting */}
      <JobPosting jobs={current_openings.data} />
      <Box>
        <Banner data={MainSec} blogCareerBanner />
        <Box as={Container} maxW="7xl" px={{ base: 5, md: 8, xl: 5 }}>
          {current_openings.data.length > 0 ? (
            <>
              <Box textAlign={"center"} my={10}>
                <Heading
                  fontSize="3xl"
                  fontWeight={"medium"}
                  pos={"relative"}
                  textAlign={"center"}
                  w={"full"}
                  color={"blue.10"}
                  mb={3}
                >
                  {Title}
                </Heading>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  fontWeight={"normal"}
                  color={"gray.10"}
                >
                  {Description}
                </Text>
              </Box>
              {isVisible && (
                <Alert
                  status="success"
                  variant="subtle"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  textAlign="center"
                  height="150px"
                >
                  <AlertIcon boxSize="30px" mr={0} />
                  <AlertTitle mt={4} mb={1} fontSize="lg">
                    Application submitted!
                  </AlertTitle>
                  <AlertDescription maxWidth="sm">
                    Thanks for submitting your application. <br />
                    We will review your application and will contact you if
                    there is a good match.
                  </AlertDescription>
                </Alert>
              )}
              <TableContainer className="vacancyOpen">
                <Table
                  variant="striped"
                  colorScheme="gray"
                  maxWidth={"100%"}
                  overflowX={"hidden"}
                >
                  <TableCaption
                    {...tableCaptionBreak}
                    mt={{ base: 0, md: 0, lg: 4 }}
                    py={{ base: 0, md: 0, lg: 2 }}
                    mb={{ base: 5, md: 5, lg: 0 }}
                  >
                    <Text whiteSpace={"break-spaces"}>
                      {" "}
                      We are always on the lookout for talented folk to join our
                      team. Follow us on
                    </Text>{" "}
                    <Link
                      color={"blue.10"}
                      href="https://www.linkedin.com/in/sparkleinfotech/"
                      target={"_blank"}
                    >
                      LinkedIn!
                    </Link>
                  </TableCaption>
                  <Thead position={"relative"} background={"blue.10"}>
                    <Tr>
                      {Headings.map((Heading, i) => (
                        <Th {...tableHeading} key={i}>
                          {Heading}
                        </Th>
                      ))}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {current_openings.data.map((jobs) => {
                      return (
                        jobs.attributes.isOpening && (
                          <Tr>
                            <Td {...tableContent} color={"blue.10"}>
                              {jobs.attributes.Developer}
                            </Td>
                            <Td {...tableContent}>
                              {jobs.attributes.Experience}
                            </Td>
                            <Td
                              textAlign={{
                                base: "left",
                                md: "left",
                                lg: "center",
                              }}
                              {...tableContent}
                            >
                              {jobs.attributes.Vacancies}
                            </Td>
                            <Td whiteSpace={"break-spaces"} {...tableContent}>
                              {jobs.attributes.Qualification}
                            </Td>
                            <Td>
                              <Stack direction={"row"}>
                                <Button
                                  variant="outline"
                                  textDecoration={"none !important"}
                                  color={"blue.10"}
                                  rounded={"md"}
                                  borderColor={"blue.10"}
                                  _hover={{ bg: "blue.10", color: "white" }}
                                  onClick={() => {
                                    onOpen();
                                    setApplyingFor({ value: jobs.attributes.Developer, label: jobs.attributes.Developer });
                                    setEnglishLevel("Advanced");
                                    setSkillLevel("Advanced");
                                  }}
                                >
                                  Apply Now
                                </Button>
                              </Stack>
                            </Td>
                          </Tr>
                        )
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Box textAlign={"center"} mb={"10"}>
              <Heading>Currently we are not hiring</Heading>
            </Box>
          )}
        </Box>
        <Box as={Container} maxW="7xl" px={{ base: 5, md: 8, xl: 0 }}>
          <Flex wrap={"wrap"} justify={"center"} textAlign={"center"}>
            <Box mt={10}>
              <Text
                fontSize="3xl"
                fontWeight={"medium"}
                pos={"relative"}
                textAlign={"center"}
                w={"full"}
                color={"blue.10"}
                mb={{ base: 0, md: 2 }}
              >
                {BenifitTitle}
              </Text>
              <Text
                fontSize={{ base: "md", md: "lg" }}
                fontWeight={"normal"}
                color={"gray.10"}
              >
                {BenifitDesc}
              </Text>
              <Grid
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                  xl: "repeat(5, 1fr)",
                }}
                gap={4}
                mt={10}
                justifyItems={"center"}
              >
                {TitleIconSection.map((ele, index) => {
                  return <BenfitCard data={ele} showIcon={true} key={index} />;
                })}
              </Grid>
            </Box>
          </Flex>
        </Box>
        <Banner data={Contact_Us} classNamechild />

        <Modal
          isOpen={isOpen}
          onClose={onClose}
          size={{ base: "full", md: "2xl", lg: "4xl" }}
          isCentered
        >
          <ModalOverlay />
          <ModalContent background={"white"}>
            <ModalHeader
              my={{ base: "5", md: "10" }}
              textAlign={"center"}
              p={0}
            >
              SUBMIT YOUR DATA
            </ModalHeader>
            <ModalCloseButton />
            <form onSubmit={(e) => handleApplyNow(e)}>
              <ModalBody pb={{ base: 0, md: 6 }}>
                <Flex mb={"5"} flexDirection={{ base: "column", md: "row" }}>
                  <FormControl mr={"10"} mb={{ base: "5", md: 0 }} isRequired>
                    <FormLabel>Full name</FormLabel>
                    <Input onChange={(e) => setFullName(e.target.value)} />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel>Email</FormLabel>
                    <Input
                      onChange={(e) => setEmail(e.target.value)}
                      type={"email"}
                    />
                  </FormControl>
                </Flex>
                <Flex mb={"5"} flexDirection={{ base: "column", md: "row" }}>
                  <FormControl mr={"10"} mb={{ base: "5", md: 0 }} isRequired>
                    <FormLabel>Contact Number</FormLabel>
                    <Input
                      onChange={(e) => setContact(e.target.value)}
                      required
                    />
                  </FormControl>

                  <FormControl>
                  <FormLabel>English Level</FormLabel>
                    <Select
                      value={skillLevel}
                      onChange={(e) => setSkillLevel(e.target.value)}
                    >
                      <option value="Beginner">Beginner</option>
                      <option value="Basic">Basic</option>
                      <option value="Intermediate">Intermediate</option>
                      <option value="Advanced">Advanced</option>
                    </Select>
                  </FormControl>
                </Flex>
                <Flex mb={"5"} flexDirection={{ base: "column", md: "row" }}>
                  <FormControl mr={"10"} mb={{ base: "5", md: 0 }} isRequired>
                  <FormLabel>Applying For</FormLabel>
                  <SelectC
                    instanceId="chakra-react-select-1"
                    isMulti
                    onChange={(e) => setApplyingFor(e)}
                    defaultValue={applyingFor}
                    name="Applying For"
                    options={groupedOptions}
                    placeholder="Select some ..."
                    closeMenuOnSelect={false}
                  />
                </FormControl>
                <FormControl>
                    <FormLabel>Technology Skill</FormLabel>
                    <Select
                      value={englishLevel}
                      onChange={(e) => setEnglishLevel(e.target.value)}
                    >
                      <option value="Beginner">Beginner</option>
                      <option value="Basic">Basic</option>
                      <option value="Intermediate">Intermediate</option>
                      <option value="Advanced">Advanced</option>
                    </Select>
                  </FormControl>
                </Flex>
                <Flex mb={"5"} flexDirection={{ base: "column", md: "row" }}>
                  <FormControl isRequired>
                    <FormLabel>Upload File</FormLabel>
                    <InputGroup alignItems={"center"}>
                      <input
                        type={"file"}
                        multiple={false}
                        hidden
                        accept=".pdf,.doc,.docx,.txt,.html"
                        onChange={handleFileUpload}
                        ref={(e) => {
                          inputRef.current = e;
                        }}
                      />
                      <>
                        <Button
                          onClick={handleClick}
                          leftIcon={<Icon as={FiFile} />}
                        >
                          Upload CV
                        </Button>
                      </>
                      <Text ml={"5px"}>{uploadedFile?.name}</Text>
                    </InputGroup>
                  </FormControl>
                </Flex>

                <Box mr={"10"} mb={{ base: "5", md: 0 }}>
                  {/* reCAPTCHA verification */}
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    size="normal"
                    sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                    onChange={onReCAPTCHAChange}
                  />

                  {captchaError && (
                    <Text color={"red.600"}>{captchaError}</Text>
                  )}
                </Box>
              </ModalBody>

              <ModalFooter py={{ base: 0, md: 4 }}>
                <Button
                  type="submit"
                  colorScheme="blue"
                  mr={3}
                  id="apply_btn"
                  isLoading={isSubmiited}
                  loadingText="Submitting"
                  isDisabled={isDisabled}
                >
                  Submit
                </Button>
                <Button onClick={onClose}>Cancel</Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default Career;
